console.log("script pre-copy");

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("pre").forEach(pre => {
        const button = document.createElement("button");
        button.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-icon-copy"><title>Copier ce bloc dans le presse-papier</title><use href="/static/icons/uga.svg#icon-copy"></use>
        </svg>`;
        button.addEventListener("click", () => {
            navigator.clipboard.writeText(pre.innerText)
                .then(() => console.log("Text copied to clipboard..."))
                .catch(err => console.log("Something went wrong", err));
        });
        pre.appendChild(button);
    });
});